$(function () {
  $("#overlay").on("click", function () {
    videoControl("stopVideo");
  });

  function videoControl(action) {
    var $playerWindow = $('.mov')[0].contentWindow;
    $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
  }
});